import { useEffect } from 'react'
import { useChatPanel } from './useMobileMenu'
import { eventBus } from '@/shared/lib/eventBus'

export function useKeyboardShortcuts() {
  const { toggleChat, closeChat, isFullscreen, isChatOpen } = useChatPanel()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Cmd+Shift+K (Mac) or Ctrl+Shift+K (Windows/Linux) to toggle chat sidebar
      // When in fullscreen, close entirely rather than toggling to sidebar
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.code === 'KeyK') {
        e.preventDefault()
        if (isFullscreen && isChatOpen) {
          closeChat()
        } else {
          toggleChat()
        }
      }

      // Cmd+N (Mac) or Ctrl+N (Windows/Linux) to start a new chat
      // ChatPanel guards this: no-ops if the current conversation is already empty
      if ((e.metaKey || e.ctrlKey) && !e.shiftKey && e.code === 'KeyN') {
        e.preventDefault()
        eventBus.emit('chat:newConversation')
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [toggleChat, closeChat, isFullscreen, isChatOpen])
}
